import "../sass/main.scss";

import "slick-carousel/slick/slick";

import "./script-modal";
import "./_sprite";
import "./faq";
import "./video-testimonials";
import "./trustpilot-consent";

let pattern_row = '<svg preserveAspectRatio="none" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1920 36.9514L1920 41.0002L-9.20075e-07 41.0002L-8.27246e-07 36.8636C253.87 13.951 590.37 7.18365e-07 959.5 7.18365e-07C1329.12 -0.00366001 1666.01 13.984 1920 36.9514Z" fill="currentColor"/></svg>';

jQuery(document).ajaxComplete(function () {
    initialiseMain();
});
jQuery(window).resize(function () {
    stickToSides();
});

jQuery(window).scroll(function() {
    stickyNav();
});
jQuery(document).ready(function () {
    initialiseMain();
    stickToSides();
    addPattern();
    stickyNav();

    /*
     * Pattern H2
     */
    let h2 = jQuery('h2:not(.h1):not(.h3):not(.h4):not(.h5):not(.h6):not(.vc_tta-panel-title), .h2');
    h2.each(function () {
        let content = jQuery(this).html();
        content = content.split(' ');
        content[0] = '<span class="h2--before"><span class="h2--before__content">' + content[0] + '</span></span>';
        jQuery(this).html(content.join(' '));
    });
    /* END */

    let container = jQuery(document).width();

    if (container >= 1280) {
        jQuery('.has-mega-menu > a, .has-mega-menu > span').click(function () {
            jQuery('.header__logo').removeClass('is-white');
        });
    }

    document.addEventListener(
        "click",
        function (event) {
            if (!event.target.closest(".mega-menu")) {
                jQuery('.header__logo').addClass('is-white');
            }
        },
        false
    )

    jQuery('.tta-collapse-content').each(function (event) {
        let element = jQuery(this);
        let title = jQuery(this).parent().find('h2');

        element.hide();
        title.addClass('tta-collapse-content-title').click(function(){
            jQuery(this).toggleClass('active');
            element.slideToggle('slow');
        });
    });
});

function initialiseMain() {
    // Burger principal (ouverture/fermeture du menu mobile)
    jQuery('.header__menu > .js-menu-burger')
        .off('click.main-burger')
        .on('click.main-burger', function () {
            jQuery(this).toggleClass('is-active');
            jQuery('html').toggleClass('is-active-modal is-active-menu-burger');
        });

    /*
     * Sous-menus dans le menu burger (mobile)
     * - On ne touche pas au comportement desktop (>= 1280px)
     */
    const MOBILE_BREAKPOINT = 1280;

    const viewportWidthInit = jQuery(window).width();

    // Normaliser l'état initial des sous-menus UNIQUEMENT pour la version burger (mobile)
    if (viewportWidthInit < MOBILE_BREAKPOINT) {
        // On limite au bouton \"Espaces privés\" (li-button-outline + menu-item-has-children)
        jQuery('.header__menu ul.menu .li-button-outline.menu-item-has-children').each(function () {
            const $parent  = jQuery(this);
            const $submenu = $parent.children('ul.menu, ul.submenu');

            if (!$submenu.length) {
                return;
            }

            if ($parent.hasClass('is-open')) {
                $submenu.show();
            } else {
                $submenu.hide();
            }
        });
    }

    // Sous-menus du burger (mobile) : on utilise l'icône burger interne, pas le lien
    // Limité au bouton \"Espaces privés\" (li-button-outline.menu-item-has-children)
    jQuery('.header__menu ul.menu .li-button-outline.menu-item-has-children > .menu-burger')
        .off('click.submenu-toggle')
        .on('click.submenu-toggle', function (e) {
            const viewportWidth = jQuery(window).width();

            // Sur desktop, on laisse le hover / mega-menu gérer l'ouverture
            if (viewportWidth >= MOBILE_BREAKPOINT) {
                return;
            }

            e.preventDefault();
            const $parent  = jQuery(this).closest('.li-button-outline.menu-item-has-children');
            const $submenu = $parent.children('ul.menu, ul.submenu');

            if ($submenu.length) {
                const isOpen = $parent.hasClass('is-open');

                if (isOpen) {
                    $parent.removeClass('is-open');
                    $submenu.stop(true, true).slideUp(200);
                } else {
                    $parent.addClass('is-open');
                    $submenu.stop(true, true).slideDown(200);
                }
            }
        });

    /*
     * Pouvoir cliquer sur l'ensemble d'une carte
     */
    jQuery('.js-card').click(function () {
        let attr_target = jQuery(this).find('.js-button').attr('target');
        let attr_href = jQuery(this).find('.js-button').attr('href');
        if(attr_target && attr_target === '_blank') {
            window.open(attr_href, '_blank').focus();
        } else {
            window.location.href = attr_href;
        }
    }).hover(function () {
        jQuery(this).find('.js-button').toggleClass('is-active');
    });

    jQuery('.js-card a:not(.js-button)').click(function (e) {
        e.stopPropagation()
    })
}

function addPattern() {
    jQuery('.pattern-before:not(.pattern-before-is-loaded)').each(function () {
        let pattern_use = pattern_row;
        // if (jQuery(this).hasClass('pattern-before-2')) {
        //     pattern_use = pattern_row_2;
        // }

        let elt_class = jQuery(this).attr('class').split(' ');
        let pattern_color = 'color-primary';
        let pattern_bg_color = '';
        for (let i = 0; i < elt_class.length; i++) {
            if (elt_class[i].slice(0, 20) === 'pattern-before-color') {
                pattern_color = elt_class[i].slice(15);
            }

            if (elt_class[i].slice(0, 23) === 'pattern-before-bg-color') {
                pattern_bg_color = elt_class[i].slice(15);
            }
        }

        let block = jQuery('<div class="block-pattern block-pattern-before ' + pattern_color + ' ' + pattern_bg_color + '">' + pattern_use + '</div>').prependTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-before-no-margin'))
            jQuery(this).css('margin-top', height);

        // let prevRow;
        // if (jQuery(this).hasClass('vc_row')) {
        //     prevRow = jQuery(this).prev();
        //     if (prevRow.hasClass('vc_clearfix')) {
        //         prevRow = prevRow.prev();
        //     }
        // } else {
        //     prevRow = jQuery(this).prev();
        //     if (prevRow.hasClass('site-content')) {
        //         let vc_rows = prevRow.find('.vc_row');
        //         let count_vc_rows = vc_rows.length;
        //         prevRow = vc_rows.eq(count_vc_rows);
        //     }
        // }

        // if (prevRow.length) {
        //     let paddingBottomOfPrevRow = prevRow.css('padding-bottom');
        //     paddingBottomOfPrevRow = paddingBottomOfPrevRow.slice(0, -2);
        //     paddingBottomOfPrevRow = parseInt(paddingBottomOfPrevRow);
        //     paddingBottomOfPrevRow = paddingBottomOfPrevRow + height;
        //     prevRow.css('padding-bottom', paddingBottomOfPrevRow);
        // }

        jQuery(this).addClass('pattern-before-is-loaded');

        // patternBgColor(jQuery(this), block);
    });

    jQuery('.pattern-after:not(.pattern-after-is-loaded)').each(function () {
        let pattern_use = pattern_row;
        // if (jQuery(this).hasClass('pattern-after-2')) {
        //     pattern_use = pattern_row_2;
        // }

        let elt_class = jQuery(this).attr('class').split(' ');
        let pattern_color = 'color-primary';
        let pattern_bg_color = '';
        for (let i = 0; i < elt_class.length; i++) {
            if (elt_class[i].slice(0, 19) === 'pattern-after-color') {
                pattern_color = elt_class[i].slice(14);
            }

            if (elt_class[i].slice(0, 23) === 'pattern-after-bg-color') {
                pattern_bg_color = elt_class[i].slice(15);
            }
        }

        let block = jQuery('<div class="block-pattern block-pattern-after ' + pattern_color + ' ' + pattern_bg_color + '">' + pattern_use + '</div>').appendTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-after-no-margin'))
            jQuery(this).css('margin-bottom', height);

        // let nextRow;
        // if (jQuery(this).hasClass('vc_row')) {
        //     nextRow = jQuery(this).next();
        //     if (nextRow.hasClass('vc_clearfix')) {
        //         nextRow = nextRow.next();
        //     }
        // } else {
        //     nextRow = jQuery(this).next();
        //     if (nextRow.hasClass('site-content')) {
        //         nextRow = nextRow.find('.vc_row').eq(1);
        //     }
        // }

        // if (nextRow.length) {
        //     let paddingBottomOfNextRow = nextRow.css('padding-top');
        //     paddingBottomOfNextRow = paddingBottomOfNextRow.slice(0, -2);
        //     paddingBottomOfNextRow = parseInt(paddingBottomOfNextRow);
        //     paddingBottomOfNextRow = paddingBottomOfNextRow + height;
        //     nextRow.css('padding-top', paddingBottomOfNextRow);
        // }

        jQuery(this).addClass('pattern-after-is-loaded');

        // patternBgColor(jQuery(this), block);
    });
}

function patternBgColor(parent, block) {
    if (jQuery(parent).hasClass('pattern-before-bg-color-primary')) {
        block.addClass('block-pattern-bg-color-primary');
    } else if (jQuery(parent).hasClass('bg-color-secondary')) {
        block.addClass('block-pattern-bg-color-secondary');
    } else if (jQuery(parent).hasClass('bg-color-tertiary')) {
        block.addClass('block-pattern-bg-color-tertiary');
    } else if (jQuery(parent).hasClass('bg-color-white')) {
        block.addClass('block-pattern-bg-color-white');
    } else if (jQuery(parent).hasClass('bg-color-black')) {
        block.addClass('block-pattern-bg-color-black');
    } else if (jQuery(parent).hasClass('pattern-before-bg-color-neutral-3')) {
        block.addClass('block-pattern-bg-color-neutral-3');
    }
}

function stickToSides() {
    let minWidth = 1440;
    let maxWidth = 2300;
    let $window = jQuery(window);

    jQuery('.stickToLeft').each(function () {
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var left = offset;

        if ($window.width() > minWidth && $window.width() < maxWidth) {
            jQuery(this).css('margin-left', -offset);
            jQuery(this).width(width + left);
        } else
            jQuery(this).css('margin-left', '');
    });

    jQuery('.stickToRight').each(function () {
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var right = $window.width() - (offset + width)

        if ($window.width() > minWidth && $window.width() < maxWidth) {
            jQuery(this).css('margin-right', -right);
            jQuery(this).width(width + right);
        } else
            jQuery(this).css('margin-right', '');
    });
}

function stickyNav(){
    if(jQuery('header').length > 0)
    {
        var $window = jQuery(window);
        var $document = jQuery(document);
        var docViewTop = $window.scrollTop();

        // if(isInvisibleInWindow(jQuery('.header-wrapper'))) jQuery('body').addClass('sticky-menu');
        // else if( docViewTop == 0 ) jQuery('body').removeClass('sticky-menu');

        var windowHeight = $window.height();
        var documentHeight = $document.height();
        var diff = windowHeight - documentHeight

        if(docViewTop > 10 && diff < -200) jQuery('body').addClass('sticky-menu');
        else jQuery('body').removeClass('sticky-menu');
    }
}
